
import { CatalogueCode, CodeCategory } from '.';
import { PriceBook } from '..';
import { Entity } from '../entity';

export interface CodePrice {
    _id: string; // Code Name + PriceBook Id
    name: string;
    description: string;
    category: CodeCategory;
    priceBook: Entity;
    price: number;
}

export interface CodePriceInfo {
    code: string;
    price: number;
}

export type CodeLike = CatalogueCode | CodePrice;

export function getCodePriceKey(codeName: string, pricelistId: string): string {
    return `${codeName}-${pricelistId}`;
}

export function getCodePrice(code: CodeLike, pricelist: PriceBook, price = 0): CodePrice {
    const codePrice = {
        _id: getCodePriceKey(code?.name, pricelist?._id),
        name: code.name,
        description: code.description,
        category: code.category,
        price: price,
        priceBook: {
            _id: pricelist._id,
            name: pricelist.name
        }
    } as CodePrice;

    return codePrice;
}
